import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { BoReference } from './bo-reference.js'

@jsonClass('Permission')
export class Permission extends BusinessObject {
	@jsonArrayProperty(BoReference)
	childPermissions: BoReference[] = []

	constructor(init?: Partial<Permission>) {
		super()
		assignCommonProperties(this, init)
	}
}
